export default __webpack_public_path__ + "static/media/autorep2.fc80c5f8.jpg";